import React, { useState } from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import { motion, Variants } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import ThemeToggle from '../ThemeToggle/ThemeToggle';
import './Header.css';

const Header: React.FC = () => {
  const [expanded, setExpanded] = useState(false);
  const { darkMode } = useTheme();

  const navVariants: Variants = {
    hidden: { opacity: 0, y: -50 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { 
        type: 'spring' as const, 
        stiffness: 120, 
        duration: 0.7 
      } 
    }
  };

  const linkVariants = {
    hover: { 
      scale: 1.1,
      color: '#007bff',
      transition: { duration: 0.3 }
    }
  };

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={navVariants}
    >
      <Navbar 
        bg={darkMode ? "dark" : "light"} 
        variant={darkMode ? "dark" : "light"}
        expand="lg" 
        className="navbar-custom" 
        expanded={expanded}>
        <Container>
          <Navbar.Brand as={Link} to="/">
            <motion.div 
              whileHover={{ scale: 1.1 }}
              className="logo"
            >
              Muhammad Rahim
            </motion.div>
          </Navbar.Brand>
          <Navbar.Toggle 
            aria-controls="basic-navbar-nav" 
            onClick={() => setExpanded(expanded ? false : true)}
          />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link as={Link} to="/">
                <motion.span variants={linkVariants} whileHover="hover">
                  Home
                </motion.span>
              </Nav.Link>
              <Nav.Link as={Link} to="/about">
                <motion.span variants={linkVariants} whileHover="hover">
                  About
                </motion.span>
              </Nav.Link>
              <Nav.Link as={Link} to="/skills">
                <motion.span variants={linkVariants} whileHover="hover">
                  Skills
                </motion.span>
              </Nav.Link>
              <Nav.Link as={Link} to="/projects">
                <motion.span variants={linkVariants} whileHover="hover">
                  Projects
                </motion.span>
              </Nav.Link>
              <Nav.Link as={Link} to="/contact">
                <motion.span variants={linkVariants} whileHover="hover">
                  Contact
                </motion.span>
              </Nav.Link>
              <div className="theme-toggle-container ms-2 d-flex align-items-center">
                <ThemeToggle />
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </motion.div>
  );
};

export default Header;
